import projection from '../generated/pwn501f1.json';
import { AcceptanceManifest } from '../types';
export const pwn501f1AcceptanceManifest = projection as AcceptanceManifest;
